/**
 * BuzzPin — Brand pin icon (replaces emoji 📍 across the app).
 *
 * Visual: classic teardrop pin with cyan→blue gradient body, white inner ring,
 * orange center dot — mirrors the Buzzmap logo (`/logo.png`).
 *
 * Notes on the gradient id:
 *   The `<linearGradient>` uses a fixed id "buzzpin-grad". When multiple BuzzPin
 *   instances render on the same page, all `<defs>` share the same id, which is
 *   safe because they describe the same gradient (no visual conflict).
 */

export interface BuzzPinProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
}

export function BuzzPin({ size = 18, className, ariaHidden = true }: BuzzPinProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden={ariaHidden}
    >
      <defs>
        <linearGradient id="buzzpin-grad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#22D3EE" />
          <stop offset="100%" stopColor="#2563EB" />
        </linearGradient>
      </defs>
      {/* Pin teardrop */}
      <path
        d="M12 2C7.58 2 4 5.58 4 10c0 5.5 8 12 8 12s8-6.5 8-12c0-4.42-3.58-8-8-8z"
        fill="url(#buzzpin-grad)"
      />
      {/* White ring */}
      <circle cx="12" cy="10" r="3.6" fill="#fff" />
      {/* Orange dot */}
      <circle cx="12" cy="10" r="2.2" fill="#F97316" />
    </svg>
  );
}
